export default {
  deleteReview: 'Odstrániť recenziu',
  deleteReviewConfirm: 'Naozaj si želáte odstrániť túto recenziu?'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/routes/reviews.js